export default {
  apiKey: "AIzaSyC9WAz0R9ZrXZKew6F6FhNEe2lQuVlRaaE",
  authDomain: "drp43-55351.firebaseapp.com",
  projectId: "drp43-55351",
  storageBucket: "drp43-55351.appspot.com",
  messagingSenderId: "763553709761",
  appId: "1:763553709761:web:1b18036560220498921e40",
  measurementId: "G-V1KPDQ5M86"
};